// extracted by mini-css-extract-plugin
export default {"app_container":"center-with-sidebar_app_container__Exfgh","lang":"center-with-sidebar_lang__z+gu6"};